// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails');

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import Rails from '@rails/ujs';
import 'bootstrap/dist/js/bootstrap';
import 'jquery-jpostal-ja';
import Vue from 'vue/dist/vue.esm';
import PhotoIdentity from '../components/PhotoIdentity.vue';
import IdentityDocumentInput from '../components/IdentityDocumentInput.vue';
import * as Sentry from '@sentry/vue';
import '../lib/icon';
if (typeof Element.prototype.animate !== 'function') {
  import('web-animations-js/web-animations.min');
}
import slideForHitaimen from '../lib/slide_for_hitaimen.js';
import '../controllers';
import $ from 'jquery';
import '@hotwired/turbo-rails';
import TurbolinkAdapter from 'vue-turbolinks';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.vueIntegration({ attachProps: true })],
  });
}

window.$ = window.jQuery = $;

if (!window._rails_loaded) {
  Rails.start();
}
// eslint-disable-next-line no-undef
Turbo.config.forms.mode = 'optin';
Vue.use(TurbolinkAdapter);

const init = () => {
  if (
    typeof window.fetch === 'function' &&
    typeof Array.prototype.map === 'function' &&
    document.getElementById('slidehitaimen')
  ) {
    slideForHitaimen();
  }

  $('#client_email, #client_email_confirmation').on('keyup change', () => {
    let email = $('#client_email').val();
    let email_confirmation = $('#client_email_confirmation').val();
    let submit = $('[type=submit]');
    let result = !(
      email == email_confirmation &&
      email.length > 0 &&
      email_confirmation.length > 0
    );
    submit.attr('disabled', result);
  });

  $('#zipcode').jpostal({
    postcode: ['#zipcode'],
    address: {
      '#address1': '%3%4%5',
    },
    url: {
      http: 'https://jpostal-1006.appspot.com/json/',
      https: 'https://jpostal-1006.appspot.com/json/',
    },
  });
};

const vueMount = () => {
  new Vue({
    el: document.getElementById('photo-approve-form'),
    name: 'PhotoApproveForm',
    components: {
      PhotoIdentity,
    },
    data() {
      return {
        setting: undefined,
        identityDocumentType: '',
        attachments: {
          1: false,
          2: false,
          3: false,
          4: false,
        },
      };
    },
    computed: {
      requiresBackSide() {
        return this.identityDocumentType !== 'mynumber';
      },
      isDocumentTypeSelected() {
        return this.identityDocumentType.length > 0;
      },
      isAllAttached() {
        if (!this.isDocumentTypeSelected) {
          return false;
        }

        const requiredAttachmentIndices = this.requiresBackSide
          ? [1, 2, 3, 4]
          : [1, 3, 4];

        return requiredAttachmentIndices.every(
          (index) => this.attachments[index]
        );
      },
    },
    watch: {
      identityDocumentType() {
        this.attachments[2] = false;
      },
    },
    async mounted() {
      const fileInput = this.$refs.file;
      const documentTypeInput = this.$refs.documentType;
      this.setting = {
        directUploadUrl: fileInput.dataset.directUploadUrl,
        name: fileInput.name,
      };
      if (documentTypeInput && documentTypeInput.value.length > 0) {
        this.identityDocumentType = documentTypeInput.value;
      }
    },
    methods: {
      async cameraCheck() {
        let stream;
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: this.facingMode },
          });
        } catch {
          return false;
        }
        stream.getVideoTracks().forEach((track) => track.stop());
        return true;
      },
      onUploading(index) {
        this.attachments[index] = false;
      },
      onAttached(index) {
        this.attachments[index] = true;
      },
    },
  });

  new Vue({
    el: document.getElementById('camera-check'),
    name: 'CameraCheck',
    data() {
      return {
        result: false,
      };
    },
    async mounted() {
      if (!location.search.includes('photo')) {
        this.result = await this.cameraCheck();
      }
    },
    methods: {
      async cameraCheck() {
        let stream;
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: this.facingMode },
          });
        } catch {
          return false;
        }
        stream.getVideoTracks().forEach((track) => track.stop());
        return true;
      },
    },
  });

  new Vue({
    el: document.getElementById('identity-document-form'),
    components: {
      IdentityDocumentInput,
    },
    data() {
      return {
        setting1: undefined,
        setting2: undefined,
        identityDocumentType: 'other',
        attachments: {
          1: false,
          2: false,
        },
      };
    },
    computed: {
      requiresBackSide() {
        return this.identityDocumentType !== 'mynumber';
      },
      isAllAttached() {
        const requiredAttachmentIndices = this.requiresBackSide ? [1, 2] : [1];

        return requiredAttachmentIndices.every(
          (index) => this.attachments[index]
        );
      },
    },
    mounted() {
      if (this.$el?.dataset?.identityDocumentType) {
        this.identityDocumentType = this.$el.dataset.identityDocumentType;
      }
      this.setting1 = this.getSetting(this.$refs.file1);
      this.setting2 = this.getSetting(this.$refs.file2);
    },
    methods: {
      getSetting(input) {
        const fileInput = input;
        return {
          directUploadUrl: fileInput.dataset.directUploadUrl,
          name: fileInput.name,
        };
      },
      onAttached(index) {
        this.attachments[index] = true;
      },
    },
  });
};

document.addEventListener('turbo:load', () => {
  init();
  vueMount();
});
